import { Routes, RouterModule } from '@angular/router';

// Route for content layout with sidebar, navbar and footer
export const Full_ROUTES: Routes = [
  // {
  //   path: 'changelog',
  //   loadChildren: () => import('../../changelog/changelog.module').then(m => m.ChangeLogModule)
  // },
  // {
  //   path: 'full-layout',
  //   loadChildren: () => import('../../pages/full-layout-page/full-pages.module').then(m => m.FullPagesModule)
  // },
  {
    path: 'dashboard',
    loadChildren: () => import('../../pages/full-layout-page/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'dashboard/:appId/:Status',
    loadChildren: () => import('../../pages/full-layout-page/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'departments',
    loadChildren: () => import('../../pages/full-layout-page/department/departments.module').then(m => m.DepartmentsModule)
  },
  {
    path: 'departments/:id',
    loadChildren: () => import('../../pages/full-layout-page/department/department.module').then(m => m.DepartmentModule)
  },
  {
    path: 'trialsms',
    loadChildren: () => import('../../pages/full-layout-page/trialsms/trialsms.module').then(m => m.TrialsmsModule)
  },
  {
    path: 'applicationform',
    loadChildren: () => import('../../pages/full-layout-page/applicationform/applicationform.module').then(m => m.ApplicationformModule)
  },
  {
    path: 'paymentredirect',
    loadChildren: () => import('../../pages/full-layout-page/paymentredirect/paymentredirect.module').then(m => m.PaymentredirectModule)
  },
  {
    path: 'wifidetails',
    loadChildren: () => import('../../pages/full-layout-page/wifidetails/wifidetails.module').then(m => m.WifidetailsModule)
  },
  {
    path: 'orderrenewal/:id',
    loadChildren: () => import('../../pages/full-layout-page/orderrenewal/orderrenewal.module').then(m => m.OrderrenewalModule)
  },
  {
    path: 'updatewifidetails',
    loadChildren: () => import('../../pages/full-layout-page/updatewifidetails/updatewifidetails.module').then(m => m.UpdatewifidetailsModule)
  },
  {
    path: 'cancellationofservice',
    loadChildren: () => import('../../pages/full-layout-page/cancellationofservice/cancellationofservice.module').then(m => m.CancellationofserviceModule)
  },
  {
    path: 'changeofservice',
    loadChildren: () => import('../../pages/full-layout-page/changeofservice/changeofservice.module').then(m => m.ChangeofserviceModule)
  },
  {
    path: 'paymenthistory',
    loadChildren: () => import('../../pages/full-layout-page/paymenthistory/paymenthistory.module').then(m => m.PaymenthistoryModule)
  },
  {
    path: 'myprofile',
    loadChildren: () => import('../../pages/full-layout-page/myprofile/myprofile.module').then(m => m.MyprofileModule)
  },
  {
    path: 'manageorder',
    loadChildren: () => import('../../pages/full-layout-page/manageorder/manageorder.module').then(m => m.ManageorderModule)
  },
  {
    path: 'managecommunication',
    loadChildren: () => import('../../pages/full-layout-page/managecommunication/managecommunication.module').then(m => m.ManageCommunicationModule)
  },
  {
    path: 'manageuser',
    loadChildren: () => import('../../pages/full-layout-page/manageuser/manageuser.module').then(m => m.ManageUserModule)
  },
  {
    path: 'renewvoucher',
    loadChildren: () => import('../../pages/full-layout-page/renewvoucher/renewvoucher.module').then(m => m.RenewvoucherModule)
  },
  {
    path: 'retrypayment',
    loadChildren: () => import('../../pages/full-layout-page/retrypayment/retrypayment.module').then(m => m.RetrypaymentModule)
  },
  {
    path: 'updatecreditcard',
    loadChildren: () => import('../../pages/full-layout-page/updatecreditcard/updatecreditcard.module').then(m => m.UpdatecreditcardModule)
  },
  // {
  //   path: 'referfriends',
  //   loadChildren: () => import('../../pages/full-layout-page/referfriends/referfriends.module').then(m => m.ReferFriendsModule)
  // },

  {
    path: 'voucher',
    loadChildren: () => import('../../pages/full-layout-page/voucher/voucher.module').then(m => m.VoucherModule)
  },
  {
    path: 'voucherproducts/:id',
    loadChildren: () => import('../../pages/full-layout-page/voucherproducts/voucherproducts.module').then(m => m.VoucherProductsModule)
  },
  {
    path: 'voucherproducts',
    loadChildren: () => import('../../pages/full-layout-page/voucherproductslist/voucherproductslist.module').then(m => m.VoucherProductModule)
  },

  {
    path: 'vouchersdetail/:id',
    loadChildren: () => import('../../pages/full-layout-page/vouchersdetails/vouchersdetail.module').then(m => m.VouchersDetailModule)
  },
  {
    path: 'redeemdetails',
    loadChildren: () => import('../../pages/full-layout-page/redeemreport/redeemreport.module').then(m => m.RedeemReportModule)
  },
  {
    path: 'managepayouts',
    loadChildren: () => import('../../pages/full-layout-page/managepayouts/managepayouts.module').then(m => m.ManagepayoutsModule)
  },
  {
    path: 'managepayout/:id',
    loadChildren: () => import('../../pages/full-layout-page/managepayouts/managepayout.module').then(m => m.ManagepayoutModule)
  },
  {
    path: 'customerreport',
    loadChildren: () => import('../../pages/full-layout-page/customerreport/customerreport.module').then(m => m.CustomerreportModule)
  },
  {
    path: 'customeramendment',
    loadChildren: () => import('../../pages/full-layout-page/customeramendment/customeramendment.module').then(m => m.CustomeramendmentModule)
  },
  {
    path: 'vumatelapplicationhistory/:id',
    loadChildren: () => import('../../pages/full-layout-page/vumatelapplicationhistory/vumatelapplicationhistory.module').then(m => m.VumatelapplicationhistoryModule)
  },
  {
    path: 'singleapplicationpayment',
    loadChildren: () => import('../../pages/full-layout-page/singleapplicationpayment/singleapplicationpayment.module').then(m => m.SingleapplicationpaymentModule)
  },
  {
    path: 'manageadhoc',
    loadChildren: () => import('../../pages/full-layout-page/manageadhoc/manageadhoc.module').then(m => m.ManageadhocModule)
  },
  {
    path: 'eftpayments',
    loadChildren: () => import('../../pages/full-layout-page/eftpayments/eftpayments.module').then(m => m.EFTPaymentsModule)
  },
  {
    path: 'voucherreport',
    loadChildren: () => import('../../pages/full-layout-page/voucherreport/voucherreport.module').then(m => m.voucherreportModule)
  },
  {
    path: 'commissionreport',
    loadChildren: () => import('../../pages/full-layout-page/commissionreport/commissionreport.module').then(m => m.commissionreportModule)
  },
  {
    path: 'onceoffexpiryreport',
    loadChildren: () => import('../../pages/full-layout-page/onceoffexpiryreport/onceoffexpiryreport.module').then(m => m.onceoffexpiryreportModule)
  },
  {
    path: 'paymentreport',
    loadChildren: () => import('../../pages/full-layout-page/paymentreport/paymentreport.module').then(m => m.PaymentreportModule)
  },
  {
    path: 'failedpaymentreport',
    loadChildren: () => import('../../pages/full-layout-page/failedpayments/failedpayments.module').then(m => m.FailedpaymentsModule)
  },
  {
    path: 'eftpaymentaccountinformation',
    loadChildren: () => import('../../pages/full-layout-page/eftpaymentaccountinformation/eftpaymentaccountinformation.module').then(m => m.EftpaymentaccountinformationModule)
  },
  {
    path: 'salesreppopup',
    loadChildren: () => import('../../pages/full-layout-page/salesreppopup/salesreppopup.module').then(m => m.SalesreppopupModule)
  },
  {
    path: 'salesreptable',
    loadChildren: () => import('../../pages/full-layout-page/salesreptable/salesreptable.module').then(m => m.SalesreptableModule)
  },
  {
    path: 'applicationfail',
    loadChildren: () => import('../../pages/full-layout-page/applicationfail/applicationfail.module').then(m => m.ApplicationFailModule)
  },
  {
    path: 'payments',
    loadChildren: () => import('../../pages/full-layout-page/payment/payment.module').then(m => m.PaymentModule)
  },
  {
    path: 'payments/:id',
    loadChildren: () => import('../../pages/full-layout-page/payment/payment.module').then(m => m.PaymentModule)
  },

  {
    path: 'resalepage',
    loadChildren: () => import('../../pages/full-layout-page/resalepage/resalepage.module').then(m => m.ResalepageModule)
  },
  {
    path: 'resaletable',
    loadChildren: () => import('../../pages/full-layout-page/resaletable/resaletable.module').then(m => m.ReSalestableModule)
  },
  {
    path: 'reseller-dashboard',
    loadChildren: () => import('../../pages/full-layout-page/reseller-dashboard/reseller-dashboard.module').then(m => m.ResellerDashboardModule)
  },
  {
    path: 'reseller-user-management',
    loadChildren: () => import('../../pages/full-layout-page/reseller-user-management/reseller-user-management.module').then(m => m.ResellerUserManagementModule)
  },
  {
    path: 'reseller-application-management',
    loadChildren: () => import('../../pages/full-layout-page/reseller-application-management/reseller-application-management.module').then(m => m.ResellerApplicationManagementModule)
  },
  {
    path: 'servicechange',
    loadChildren: () => import('../../pages/full-layout-page/servicechange/servicechange.module').then(m => m.ServicechangeModule)
  },
  {
    path: 'zoompaymentdetails',
    loadChildren: () => import('../../pages/full-layout-page/zoomproviderdetails/zoomproviderdetails.module').then(m => m.ZoomproviderdetailsModule)
  },
  {
    path: 'invoicereport',
    loadChildren: () => import('../../pages/full-layout-page/invoicereport/invoicereport.module').then(m => m.InvoicereportModule)
  },
  {
    path: 'invoicestatement',
    loadChildren: () => import('../../pages/full-layout-page/invoicestatement/invoicestatement.module').then(m => m.InvoiceStatementModule)
  },
  {
    path: 'manageotpnotification',
    loadChildren: () => import('../../pages/full-layout-page/manageotpnotification/manageotpnotification.module').then(m => m.ManageOtpNotificationModule)
  },
  {
    path: 'support-ticket',
    loadChildren: () => import('../../pages/full-layout-page/support-ticket/support-ticket.module').then(m => m.SupportTicketModule)
  },
  {
    path: 'support-status',
    loadChildren: () => import('../../pages/full-layout-page/support/support-status/support-status.module').then(m => m.SupportStatusModule)
  },
  {
    path: 'add-support',
    loadChildren: () => import('../../pages/full-layout-page/support/add-support/add-support.module').then(m => m.AddSupportModule)
  },
  {
    path: 'support-ticket-admin',
    loadChildren: () => import('../../pages/full-layout-page/support/support-ticket-admin/support-ticket-admin.module').then(m => m.SupportTicketAdminModule)
  },
  {
    path: 'add-login',
    loadChildren: () => import('../../pages/full-layout-page/add-login/add-login.module').then(m => m.AddLoginModule)
  },
  {
    path: 'referfriends',
    loadChildren: () => import('../../pages/full-layout-page/referfriends/referfriends-list/referfriends.module').then(m => m.ReferFriendsModule)
  },
  {
    path: 'manage-referral',
    loadChildren: () => import('../../pages/full-layout-page/referfriends/manage-referral/manage-referral.module').then(m => m.ManageReferralModule),
  },
  {
    path: 'paymentreminderreport',
    loadChildren: () => import('../../pages/full-layout-page/paymentreminderreport/paymentreminderreport.module').then(m => m.PaymentreminderreportModule),
  }

];
